export type PageKeyType = {
  team: RegExp;
};
export const pageKeyRegex: PageKeyType = {
  team: /\/team(.*)/,
};
